<template>
  <el-card :class="this.sizeClass"
           :body-style="{ padding: '0px', display: 'flex', 'align-items': 'stretch'}">
  <div class="indicator"
       :style="{ backgroundColor: this.value.color }">
    <!--{{ this.index + 1 }}-->
  </div>
  <div class="content">
    <h4>
      <div class="title">
        <i class="fas fa-map-pin"
           @click="togglePin"
           :style="pinStyle"/>
        {{ value.name }}
      </div>
      <span class="btn-edit disabled"
            v-if="editingMode && !editing"><i :class="this.sizeIcon"/></span>
      <span class="btn-edit"
            v-else
            @click="change"><i :class="this.sizeIcon"/></span>
    </h4>
    <p class="name-mode">
      <span v-if="this.sizeClass === 'small'">POR {{ value.mode }}</span>
      <span v-else
            :style="{ color: this.value.color, 'font-weight': 700 }">
        MODIFICANDO DATOS ...
      </span>
    </p>
    <component :is="currentComponent.name"
               v-bind="currentComponent.props"
               @remove="remove"/>
  </div>
</el-card>
</template>

<script>
import Info from './Info.vue';
import PolygonForm from './form/Polygon.vue';
import LocalityForm from './form/Locality.vue';

export default {
  name: 'SectorItem',
  components: {
    Info,
    PolygonForm,
    LocalityForm,
  },
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    editingMode: {
      type: Boolean,
      default() {
        return false;
      },
    },
    index: Number,
  },
  data() {
    return {
      editing: false,
      toggleForm: true,
      sizeClass: 'small',
      sizeIcon: 'fas fa-expand',
      components: [{
        name: 'Info',
        props: { sector: this.value },
      }, {
        name: 'PolygonForm',
        props: { sector: this.value, data: this.data },
      }, {
        name: 'LocalityForm',
        props: { sector: this.value, data: this.data },
      }],
    };
  },
  mounted() {
  },
  methods: {
    togglePin() {
      this.value.pinned = !this.value.pinned;
    },
    change() {
      this.editing = !this.editing;
      this.$emit('editing', this.editing);
      this.sizeClass = (this.sizeClass === 'small' ? 'big' : 'small');
      this.sizeIcon = (this.sizeIcon === 'fas fa-expand' ? 'fas fa-compress' : 'fas fa-expand');
      this.toggleForm = !this.toggleForm;
    },
    remove() {
      if (this.editing) this.$emit('editing', false);
      this.$emit('remove');
    },
  },
  computed: {
    currentComponent() {
      if (this.editing) {
        return this.value.mode === 'POLÍGONO' ? this.components[1] : this.components[2];
      }
      return this.components[0];
    },
    pinStyle() {
      return this.value.pinned
        ? { color: this.value.color, transform: 'rotate(30deg)' } : { color: '#a5a5a5' };
    },
  },
};
</script>

<style lang="scss" scoped>
.el-card {
  margin: 5px;
  float: left;
  display: grid;
  box-shadow: 2px 3px 9px -4px rgba(0, 0, 0, 0.1) !important;
  -webkit-box-shadow: 2px 3px 9px -4px rgba(0, 0, 0, 0.1) !important;
}
.small {
  height: 125px;
  width: calc(25% - 12px);
  transition: all 0.15s ease-out;
}
.big {
  max-height: max-content;
  width: calc(100% - 10px);
  transition: all 0.15s ease-out;
  .circle, .circle:hover {
    color: #565656 !important;
    border: 1px solid #DCDFE6 !important;
  }
}
.indicator {
  width: 6px; // 20px
  float: left;
  color: white;
  padding: 2px;
  display: flex;
  font-size: 14px;
  align-items: center;
  vertical-align: center;
  justify-content: center;
}
.content {
  display: table;
  text-align: left;
  table-layout: fixed;
  width: calc(100% - 27px);
  padding: 10px;
  .btn-edit {
    float: right;
    font-size: 14px;
    cursor: pointer;
    padding: 2px 5px;
    color: #474747;
    background-color: #f5f4f4;
  }
  .btn-edit:hover { color: #7a7a7a !important; }
  .btn-edit.disabled {
    color: #cbcbcb !important;
    cursor: not-allowed;
  }
  .name-mode {
    color: #a5a2a2;
    margin: -7px 2px 8px 26px;
    font-size: 10px;
  }
  p {
    font-size: 12px;
    margin: 0 0 2px 0;
  }
  h4 {
    width: 100%;
    margin: 0;
    display: inline-block;
    .title {
      color: #474747;
      text-transform: capitalize;
      float: left;
      width: auto;
      font-size: 15px;
      overflow: hidden;
      white-space: nowrap;
      margin: 0 10px 0 5px;
      text-overflow: ellipsis;
      max-width: calc(100% - 37px);
      .fa-map-pin {
        cursor: pointer;
        margin-right: 10px;
      }
    }
  }
}
.circle {
  padding: 4px;
  float: right;
  i { font-size: 17px; }
  border-radius: 50% !important;
}
.circle-green, .circle-green:focus {
  border: none;
  color: $fb-green;
  background-color: white;
}
</style>
